<style>
    .page-item {
        cursor: pointer;
    }
    h4 {
        text-transform: capitalize;
    }
</style>

<template>
    <div class="main-content">
        <section class="section">
          <div class="section-header">
            <h1>Pembiayaan</h1>
            <div class="section-header-breadcumb button">
                <a href="javascript:" @click.prevent="goTo('/pembiayaan/baru')" class="btn btn-icon icon-left btn-primary"><i class="far fa-edit"></i> Buat Pembiayaan</a>
            </div>
          </div>
        <div class="section-body">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                    <div class="card-header">
                        <h4>Daftar Pembiayaan</h4>
                        <div class="card-header-form">
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="filter" @keyup.enter="setFilter()" placeholder="Search">
                                <div class="input-group-btn">
                                    <button @click="setFilter()" class="btn btn-primary"><i class="fas fa-search"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body p-0">
                        <div class="table-responsive">
                            <table class="table table-bordered table-md">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Tanggal Pembiayaan</th>
                                        <th>Nomor Pembiayaan</th>
                                        <th>Kategori</th>
                                        <th>Penerima</th>
                                        <th>Status</th>
                                        <th>Total Tagihan</th>
                                    </tr>
                                </thead>
                                
                                <tbody>
                                    <tr style="cursor:pointer;" v-for="list in pembiayaanList" v-bind:key="list.main.id_pembiayaan" @click="goDetail(list.main.id_pembiayaan)">
                                        <td>{{ list.no }}</td>
                                        <td> {{ list.main.tanggal_transaksi | moment("DD MMMM YYYY") }} </td>
                                        <td> {{ list.main.nomor_pembiayaan }} </td>
                                        <td> {{ list.main.kategori }} </td>
                                        <td> {{ list.main.display_name }} </td>
                                        <td> <span v-html="statusCallback(list.main.status)"></span> </td>
                                        <td> Rp. {{ currencyFormat(list.main.total_biaya) }} </td>
                                    </tr>
                                </tbody>
                                
                            </table>
                        </div>
                    </div>
                    <div class="card-footer text-right">
                        <nav class="d-inline-block">
                        <ul class="pagination mb-0">
                            <li class="page-item disabled">
                                <a class="page-link" href="#" tabindex="-1"><i class="fas fa-chevron-left"></i></a>
                            </li>
                            <li v-for="pages in pagination" v-bind:key="pages" class="page-item" :class="{ active: pages == page}">
                                <span class="page-link" @click="tableTo(pages)">{{ pages }}</span>
                            </li>
                            <li class="page-item">
                                <a class="page-link" href="#"><i class="fas fa-chevron-right"></i></a>
                            </li>
                        </ul>
                        </nav>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        </section>
    </div>
</template>
<script>
import Vue from 'vue'
import VModal from 'vue-js-modal'

Vue.use(VModal)

export default {
    data() {
        return {
            pembiayaanList : [],
            perPage: 10,
            page: 1,
            search: '',
            maxPagination: 5,
            first: 1,
            last: '',
            totalRow: '',
            pagination: [],
            url : '',
            filter : ''
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init: function() {
            this.$root.is_loading = !this.$root.is_loading;
            this.$http.get("Finance/getPembiayaanList"+"?perPage="+this.perPage+"&page="+this.page+"&search="+this.filter).then(result => {
			    if(result.data.code == '00') {
                    alert('failed get produk')
                }
                else {
                    this.pembiayaanList = result.data.detail.data;
                    this.totalRow = result.data.detail.totalRow;
                    this.last = Math.ceil(this.totalRow / this.perPage)
                    this.pagination = this.getPaging();
                }
                this.$root.is_loading = !this.$root.is_loading;
			}, error => {
                this.$root.is_loading = !this.$root.is_loading;
				console.log('gk ok')
				context.errors = errors;
            });
        },
        goTo: function(paths) {
            this.$router.push({ path : paths })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
            // this.$router.go();
        },
        getPaging: function() {
            var i;
            var paging = []
            if(this.page > this.first+2){
                this.first = this.page-3
            }else if(this.page == this.first && this.first != 1){
                this.first = this.page-3
                if(this.first < 1){
                    this.first = 1
                }
            }
            for(i = this.first;i < 6+this.first && i <= this.last; i++){
                paging.push(i)
            }
            return paging;
        },
        tableTo: function(page){
            this.page = page
            this.init();
        },
        goDetail: function(id_pembiayaan){
            var u = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
            this.$router.push({ path : 'detail/'+id_pembiayaan })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
        },
        currencyFormat: function(val){
            return this.$parent.currencyFormat(val)
        },
        setFilter: function() {
            this.init();
        },
        statusBayarCallback: function(val) {
            if(val == 1){
                return '<span style="color:green;">Dibayar</span>'
            }else{
                return '<span style="color:red;">Belum Dibayar</span>'
            }
        },
        statusCallback: function(val) {
            if(val == 1){
                return '<span style="color:green;">Dibayar</span>'
            }else{
                return '<span style="color:red;">Belum Dibayar / Belum Lunas</span>'
            }
        },
        showModalPayment: function() {
            this.$modal.show('make-payment');
        },
        hideModalPayment: function() {
            this.$modal.hide('make-payment');
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/pembiayaan/Daftar.vue